import { EShopCategory } from '~/src/api/content/shop/getShopItems';
import { goToNextStep } from '~/src/features/full-buy/store/actions/goToNextStep';
import { goToPrevStep } from '~/src/features/full-buy/store/actions/goToPrevStep';
import { selectCurrentTariff } from '~/src/features/full-buy/store/selectors/selectCurrentTariff';
import { TAppThunkDispatch, TGetState } from '~/src/store';

/**
 * Пропускаем шаг выбора приставки:
 * для моно-тарифов
 * если есть обязательная приставка в тарифе
 * если а/б тест - не отображать приставку
 */
export const skipEquipmentTvStep = () => (dispatch: TAppThunkDispatch, getState: TGetState) => {
    const state = getState();
    const selectedTariff = selectCurrentTariff(state);
    const { stepIndex, prevStepIndex } = state.fullBuy;

    const isBackward = prevStepIndex > stepIndex;

    const hasRequiredTvBox = selectedTariff?.additionalProducts.find(el => el.category === EShopCategory.Decoders && el.required);

    if (selectedTariff?.isMono || hasRequiredTvBox) {
        // пропускаем экран приставок
        dispatch(isBackward ? goToPrevStep() : goToNextStep());
    }
};
